import React, {useContext, useEffect, useState} from "react";
import "./Header.css";
import "../../app/nicepage.css";
import "../../app/App.css";
import {useHistory} from "react-router-dom";
import {dataContext} from "../../context/";
import {UserOutlined} from '@ant-design/icons';
import {Avatar} from 'antd';
import {SERVLET_PATH, VirtualHost} from "../../constants";

function Header(props) {
    const {currentUser, setIsAdminPanelOpen} = useContext(dataContext);
    const [isActive, setIsActive] = useState(false);
    const [isActiveProfile, setIsActiveProfile] = useState(false);

    let history = useHistory();

    function openAdminPanel() {
        setIsAdminPanelOpen(true);
        history.push("/kampanyalarıDüzenle");
    }
    function openFuelCampaignTablePage() {
            setIsAdminPanelOpen(true);
            history.push("/user");
        }

    function openUserOperationsPage() {
             setIsAdminPanelOpen(true);
             history.push("/eczacı-kart-kullanicilar");
             }

    const headerTabs = currentUser.name === "kirmizi" ?
        [
            {id: 1, desc: "Anasayfa", href: "/home"},
            {id: 2, desc: "Kampanyalar", href: "/Kampanyalar"},
            {id: 3, desc: "Kimlik Kart Talep Et", href: "/Kimlik-Kart-Talep-Et",},
            {id: 4, desc: "Bize Ulaşın", href: "/Bize-Ulaşın"},
        ] :
        [
            {id: 1, desc: "Anasayfa", href: "/"},
        ];

    // return (
    //     <header
    //         className="u-align-center-sm u-align-center-xs u-clearfix u-header u-sticky u-white u-header"
    //         id="sec-2c51"
    //     >
    //         <div className="u-clearfix u-sheet u-sheet-1" style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:"1rem"}}>
    //             <a
    //                 href="/"
    //                 data-page-id="34539464"
    //                 className="u-image u-logo"
    //                 data-image-width="76"
    //                 data-image-height="76"
    //                 title="Teb EczacıKart"
    //             >
    //                 <img src={logo} alt="" className="u-logo-image u-logo-image-1"/>
    //             </a>
    //             <nav className="u-align-left  u-menu-dropdown u-offcanvas">
    //                 <div
    //                     className="menu-collapse u-custom-font u-font-oswald"
    //                     style={{fontSize: "1.25rem"}}
    //                 >
    //                     <a
    //                         className="u-button-style u-custom-text-active-color u-custom-text-color u-nav-link"
    //                         href="#"
    //                     >
    //                         <svg
    //                             className="u-svg-link"
    //                             preserveAspectRatio="xMidYMin slice"
    //                             viewBox="0 0 302 302"
    //                         >
    //                             <use
    //                                 xmlnsXlink="http://www.w3.org/1999/xlink"
    //                                 xlinkHref="#svg-8a8f"
    //                             ></use>
    //                         </svg>
    //                         <svg
    //                             xmlns="http://www.w3.org/2000/svg"
    //                             xmlnsXlink="http://www.w3.org/1999/xlink"
    //                             version="1.1"
    //                             id="svg-8a8f"
    //                             x="0px"
    //                             y="0px"
    //                             viewBox="0 0 302 302"
    //                             style={{enableBackground: "new 0 0 302 302"}}
    //                             // style="enable-background:new 0 0 302 302;"
    //                             xmlSpace="preserve"
    //                             className="u-svg-content"
    //                         >
    //                             <g>
    //                                 <rect y="36" width="302" height="30"></rect>
    //                                 <rect y="236" width="302" height="30"></rect>
    //                                 <rect y="136" width="302" height="30"></rect>
    //                             </g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                             <g></g>
    //                         </svg>
    //                     </a>
    //                 </div>
    //                 <div
    //                     className="u-custom-menu u-nav-container"
    //                     style={{float: "right"}}
    //                 >
    //                     <ul className="u-custom-font u-font-oswald u-nav u-spacing-30 u-unstyled u-nav-1">
    //                         {headerTabs.map((tabs) => {
    //                             return (
    //                                 <li key={tabs.id} className="u-nav-item">
    //                                     <a
    //                                         className={
    //                                             history.location.pathname === tabs.href
    //                                                 ? "u-border-1 u-border-active-custom-color-1 u-border-hover-custom-color-1 u-border-no-left u-border-no-right u-border-no-top u-button-style u-nav-link u-text-active-custom-color-1 u-text-hover-grey-90 u-text-palette-5-dark-2 active"
    //                                                 : "u-border-1 u-border-active-custom-color-1 u-border-hover-custom-color-1 u-border-no-left u-border-no-right u-border-no-top u-button-style u-nav-link u-text-active-custom-color-1 u-text-hover-grey-90 u-text-palette-5-dark-2"
    //                                         }
    //                                         onClick={() => history.push(tabs.href)}
    //                                         style={{padding: "8px 20px"}}
    //                                     >
    //                                         {tabs.desc}
    //                                     </a>
    //                                 </li>
    //                             );
    //                         })}
    //
    //                         {currentUser.authorities.find((role) => role.authority === "ROLE_ADMIN") ? (
    //                             <li className="u-nav-item c-pointer profile-li">
    //                                 <div className="c-pointer p-relative ">
    //                                     <Avatar icon={<UserOutlined/>}/>
    //
    //                                 </div>
    //                                 <div className="p-absolute profile-menu">
    //                                     <div className="d-flex flex-d-col">
    //                                         @{currentUser.name} <br/>
    //                                         <a
    //                                             onClick={() => {
    //                                                 openAdminPanel();
    //                                             }}
    //                                             className="c-pointer profile-menu-button"
    //                                         >
    //                                             Yönetim Paneli
    //                                         </a>
    //                                         <a
    //                                             onClick={() => {
    //                                                 props.onLogout();
    //                                             }}
    //                                             className="c-pointer profile-menu-button"
    //                                         >
    //                                             Çıkış Yap
    //                                         </a>
    //                                     </div>
    //                                 </div>
    //                             </li>
    //                         ) : (
    //                             <li className="u-nav-item c-pointer profile-li">
    //                                 <div className="c-pointer p-relative ">
    //                                     <Avatar icon={<UserOutlined/>}/>
    //
    //                                 </div>
    //                                 <div className="p-absolute profile-menu">
    //                                     <div className="d-flex flex-d-col">
    //                                         @{currentUser.name} <br/>
    //                                         <a
    //                                             onClick={() => {
    //                                                 props.onLogout();
    //                                             }}
    //                                             className="c-pointer profile-menu-button"
    //                                         >
    //                                             Çıkış Yap
    //                                         </a>
    //                                     </div>
    //                                 </div>
    //                             </li>
    //                         )}
    //                     </ul>
    //
    //                 </div>
    //                 <div className="u-custom-menu u-nav-container-collapse">
    //                     <div
    //                         className="u-align-center u-black u-container-style u-inner-container-layout u-opacity u-opacity-95 u-sidenav">
    //                         <div className="u-inner-container-layout u-sidenav-overflow">
    //                             <div className="u-menu-close"></div>
    //                             <ul className="u-align-center u-nav u-popupmenu-items u-unstyled u-nav-2">
    //                                 {headerTabs.map((tab) => {
    //                                     return (
    //                                         <li key={tab.id} className="u-nav-item">
    //                                             <a
    //                                                 className="u-button-style u-nav-link"
    //                                                 onClick={() => history.push(tab.href)}
    //                                             >
    //                                                 {tab.desc}
    //                                             </a>
    //                                         </li>
    //                                     );
    //                                 })}
    //                             </ul>
    //                         </div>
    //                     </div>
    //                     <div className="u-black u-menu-overlay u-opacity u-opacity-70"></div>
    //                 </div>
    //             </nav>
    //             <a
    //                 href="/"
    //                 data-page-id="34539464"
    //                 className="u-image u-logo"
    //                 data-image-width="76"
    //                 data-image-height="76"
    //                 title="Teb EczacıKart"
    //                 style={{width: '200px', marginBottom:'10px'}}
    //             >
    //                 <img src={tebEczacikartLogo} alt="" className="u-logo-image u-logo-image-1"/>
    //             </a>
    //         </div>
    //     </header>
    // );


    return (
        <nav className="b-navbar">
            <div className="b-navbar-container">
                <div className="b-navbar-menu">
                    <div className="b-navbar-menu-left">
                        {VirtualHost.companyLogo1 &&
                            <div className="b-navbar-menu-logo">
                                <img src={SERVLET_PATH + "/api/virtual/resource/" + VirtualHost.companyLogo1} alt=""/>
                            </div>}
                    </div>
                    <div className="b-navbar-menu-center">
                        {headerTabs.map((tab) => {
                            return (
                                <a className={history.location.pathname === tab.href ? "is-active" : ""}
                                   style={{padding: "8px 20px"}}
                                   key={tab.id}
                                   onClick={() => history.push(tab.href)}> {tab.desc}
                                </a>
                            );
                        })}

                        {currentUser.name === "kirmizi" &&
                        <div className="b-navbar-menu-profile u-nav-item c-pointer profile-li">
                            <div className="c-pointer p-relative ">
                                <Avatar icon={<UserOutlined/>}/>
                            </div>
                            <div className="p-absolute profile-menu">
                                <div className="d-flex flex-d-col align-left">
                                    <b>@{currentUser.name}</b>
                                    {currentUser.authorities.find((role) => role.authority === "ROLE_ADMIN") &&
                                        <a className="c-pointer profile-menu-button" onClick={() => {
                                            openAdminPanel();
                                        }}>
                                            Yönetim Paneli
                                        </a>
                                    }
                                    {currentUser.name === "kirmizi" &&
                                        <a className="c-pointer profile-menu-button" onClick={() => {
                                            openFuelCampaignTablePage();
                                        }}>
                                            Petrol Ofisi
                                        </a>
                                    }

                                    {currentUser.name === "kirmizi" &&
                                        <a className="c-pointer profile-menu-button" onClick={() => {
                                            openUserOperationsPage();
                                        }}>
                                            Kullanıcı İşlemleri
                                        </a>
                                    }

                                    <a className="c-pointer profile-menu-button align-left" style={{margin: "0px"}}
                                       onClick={() => {
                                           props.onLogout();
                                       }}>
                                        Çıkış Yap
                                    </a>
                                </div>
                            </div>
                        </div>}

                    </div>
                    <div className="b-navbar-menu-right">
                        {VirtualHost.companyLogo2 &&
                            <div className="b-navbar-menu-logo">
                                <img src={SERVLET_PATH + "/api/virtual/resource/" + VirtualHost.companyLogo2} alt=""/>
                            </div>}
                    </div>

                </div>
                <button className={isActive ? "b-navbar-collapse-icon is-active" : "b-navbar-collapse-icon"}
                        onClick={() => setIsActive(!isActive)}>
                    <div className="bar"/>
                </button>
            </div>
            <div className={isActive ? "b-navbar-mobile is-active" : "b-navbar-mobile"}>
                {headerTabs.map((tab) => {
                    return (
                        <a className={history.location.pathname === tab.href ? "is-active" : ""}
                           key={tab.id}
                           onClick={() => {
                               history.push(tab.href);
                               setIsActive(!isActive);
                           }}>
                            {tab.desc}
                        </a>
                    );
                })}
            </div>
        </nav>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./src/component/Header/index.js